/* eslint-disable camelcase */
export interface TopicType {
  title_key: string;
  description_key?: string;
}

export enum FormPageTypeEnum {
  ASSESSMENT = 'assessment',
  QUIZ = 'quiz',
  REFLECTION = 'reflection',
}

export enum ContentPageTypeEnum {
  ARTICLE = 'article',
  AUDIO = 'audio',
  VIDEO = 'video',
}

export type PageTypeEnum = FormPageTypeEnum & ContentPageTypeEnum;

export interface PageType {
  content: string;
  page_type: PageTypeEnum | string;
  title: string;
  topic: TopicType;
}

export interface LibraryPage {
  id: number;
  title: string;
}

export interface LibraryTopic {
  id: number;
  titleKey: string;
  pages: LibraryPage[];
}

export interface LibraryProgramTopic {
  topic: LibraryTopic;
}

export interface LibraryProgram {
  id: number;
  titleKey: string;
  description?: string;
  topics: LibraryTopic[];
}
